import { Component, Input } from '@angular/core';

@Component({
    selector: 'ifp-application-status-icon-chip',
    templateUrl: './application-status-icon-chip.component.html',
    styleUrls: ['./application-status-icon-chip.component.scss'],
    standalone: false
})
export class ApplicationStatusIconChipComponent {

  @Input() status: string;
  statusLabels = {
    'Application Created': { color: 'mat-grey-bg', icon: 'assignment', label: 'Application created' },
    'Application Incomplete': { color: 'mat-orange-bg', icon: 'error', label: 'Application incomplete' },
    'Processing': { color: 'mat-grey-bg', icon: 'assignment', label: 'Processing' },
    'Conditional Offer': { color: 'mat-darkblue-bg', icon: 'find_in_page', label: 'Conditional Offer' },
    'Underwriting': { color: 'mat-darkblue-bg', icon: 'find_in_page', label: 'Underwriting' },
    'Underwriting Missing Info': { color: 'mat-orange-bg', icon: 'error', label: 'Underwriting missing info' },
    'Approved': { color: 'mat-green-bg', icon: 'check_circle', label: 'Approved' },
    'Closing': { color: 'mat-green-bg', icon: 'assignment_turned_in', label: 'Closing' },
    'Closing Review': { color: 'mat-green-bg', icon: 'find_in_page', label: 'Closing review' },
    'Closing Incomplete': { color: 'mat-orange-bg', icon: 'error', label: 'Closing incomplete' },
    'Underwriting Call': { color: 'mat-orange-bg', icon: 'error', label: 'Underwriting call' },
    'Pending Signature': { color: 'mat-green-bg', icon: 'offline_pin', label: 'Pending signature' },
    'Application Complete': { color: 'mat-green-bg', icon: 'fact_check', label: 'Application complete' },
    'Pending Renewal': { color: 'mat-green-bg', icon: 'find_in_page', label: 'Pending Renewal' },
    'Dormant': { color: 'mat-red-bg', icon: 'snooze', label: 'Dormant' },
    'Unable to fund"': { color: 'mat-red-bg', icon: 'info', label: 'Unable to fund' }
  };
}
